export enum RecipientSubTypeEnum {
    None = 0,
    Home = 1,
    Work = 2,
    Cell = 3,
    Day = 4,
    Night = 5,
    Fax = 6
}
